<template>
<div >

	<Navbar></Navbar>
	<div class="main-content">
		<div class="container">

			<div class="import-box mt-2 mb-4 pb-3" >
				<h2 class="mt-4 text-center">{{title}}</h2>
				<p class="text-center">
					Seleccione los vehículos a los cuales desea cargarle el valor
				</p>
			</div>

			<div class="container">
				<div class="row">
					<div class="col-6">

						<div class="form-group">
							<!-- <vue-simple-suggest
								v-model="chosen"
								display-attribute="name"
								value-attribute="url"
								:list="getSuggestionList"
							></vue-simple-suggest> -->


							<label>Buscar vehículos</label>
							<div class="input-group">
								<input type="text" 
									class="form-control" 
									placeholder="Chasis, motor, marca, modelo" 
									v-model="searchTerms"
									@keyup.enter="searchCars()"
									>
								<div class="input-group-append">
									<button @click="searchCars()" class="btn btn-outline-secondary" type="button">Buscar</button>
								</div>
							</div>
						</div>

						<div class="label mt-4">
							
						</div>

						<div class="alert alert-warning" v-if="!loading && cars.length==0">
							No se han encontrado vehículos que coincidan con: {{searchTerms}}
						</div>

						<table class="table mt-2 mb-4" v-if="filteredCars.length>0">
							<tr class="table-head">
								<td>Chasis</td>
								<td>Vehículo</td>
								<td>Cliente</td>
							</tr>
							<tr v-for="item of filteredCars" :key="item.id"  @click="selectCar(item)">
								<td>{{item.chassis_number}}</td>
								<td>
									<div class="tc">
										<span class="text-primary">{{item.brand.title}}</span>
										<span >{{item.model}}</span>
									</div>
								</td>
								<td>
									<div class="tc">
										<span class="text-primary">{{item.client.name}}</span>
										<span >{{item.client.business_name}}</span>
									</div>
								</td>
							</tr>
						</table>

					</div>


					<div class="col-6">

						<b-form-group label="DUA Tránsito" v-if="action == 'dua-transit'">
							<b-form-input
								v-model="form.dua_transit"
								placeholder="Número DUA Tránsito"
								:class="{'is-invalid':validation.hasError('form.dua_transit')}"
							></b-form-input>
							<b-form-invalid-feedback>Ingrese el número de dua tránsito</b-form-invalid-feedback>
						</b-form-group>

						<b-form-group label="DUA Importación" v-if="action == 'dua-import'">
							<b-form-input
								v-model="form.dua_import"
								placeholder="Número DUA importación"
								:class="{'is-invalid':validation.hasError('form.dua_import')}"
							></b-form-input>
							<b-form-invalid-feedback>Ingrese el número de dua importación</b-form-invalid-feedback>
						</b-form-group>

						<b-form-group label="Comprobante" v-if="action == 'dua-import'" class="mt-3">
							<UploadFile 
								v-model="form.file" 
								placeholder="Adjuntar comprobante"
								:invalid="validation.hasError('form.file.id')"
								:invalid-text="'Debe subir el comrpobante de despacho'"
							></UploadFile>
						</b-form-group>


						<b-form-group label="Stock" v-if="action == 'stock'">
							<b-form-input
								v-model="form.stock"
								placeholder="Stock"
								:class="{'is-invalid':validation.hasError('form.stock')}"
							></b-form-input>
							<b-form-invalid-feedback>Ingrese el número de stock</b-form-invalid-feedback>
						</b-form-group>
						
					
						<div class="label mt-4">
							Vehículos seleccionados
						</div>

						<div class="alert alert-danger" v-if="validation.hasError('form.cars')">Debe seleccionar al menos un vehículo</div>

						<table class="table mt-2 mb-4" v-if="form.cars.length>0">
							<tr class="table-head">
								<td>Chasis</td>
								<td>Vehículo</td>
								<td>Cliente</td>
								<td></td>
							</tr>
							<tr v-for="(item, index) of form.cars" :key="item.id">
								<td>{{item.chassis_number}}</td>
								<td>
									<div class="tc">
										<span class="text-primary">{{item.brand.title}}</span>
										<span >{{item.model}}</span>
									</div>
								</td>
								<td>
									<div class="tc">
										<span class="text-primary">{{item.client.name}}</span>
										<span >{{item.client.business_name}}</span>
									</div>
								</td>
								<td>
									<div class="btn btn-xs btn-light" @click="deselectCar(index)"><i class="fa fa-times"></i></div>
								</td>
							</tr>
						</table>

						<div class="overflow-hidden mt-3">
							<button type="submit" class="btn btn-primary pull-right" @click="save()" >Confirmar solicitud</button>
						</div>

					</div>

				</div>
			</div>

			
		</div>
	</div>

	<Loader :show="saving || loading"></Loader>
	
</div>
</template>

<script>
import gql from 'graphql-tag'
import mixins from '@/mixins/mixins'
import Navbar from '@/components/Navbar'
import Loader from '@/components/Loader'
import UploadFile from '@/components/UploadFile'

import SimpleVueValidation from 'simple-vue-validator';
const Validator = SimpleVueValidation.Validator;


export default {
	name: 'requestDeliveryModal',
	components:{
		Navbar,
		Loader,
		UploadFile
	},
	mixins: [mixins],
	data () {
		return {
			title: null,
			action: null,
			searchTerms:null,
			statusFilter:null,
			search_timeout: null,
			form: {
				dua_transit: null,
				dua_import: null,
				stock: null,
				cars:[],
				file:{
					id: null
				},
			},
			cars: [],
			loading: false,
			saving: false,
		}
	},
	computed: {
		filteredCars: function () {
			return this.cars.filter((car) => {
				if( this.form.cars.map( el => el.id ).indexOf(car.id) < 0 ){
					return car
				}
			}
		)}
	},
	beforeMount(){
		this.action = this.$route.params.action

		if(this.action == 'dua-import'){
			this.title = 'Carga de DUA Importación'
			this.statusFilter = 'EMPTY_DUA_IMPORT'
		}
		if(this.action == 'dua-transit'){
			this.title = 'Carga de DUA Tránsito'
			this.statusFilter = 'EMPTY_DUA_TRANSIT'
		}
		if(this.action == 'dua-stock'){
			this.title = 'Carga de Stock'
			this.statusFilter = 'EMPTY_DUA_STOCK'
		}
		// this.searchCars()
	},
	validators: {
		'form.dua_transit': function (value) {
			if(this.action == 'dua-transit'){
				return Validator.value(value).required();
			}
		},
		'form.dua_import': function (value) {
			if(this.action == 'dua-import'){
				return Validator.value(value).required();
			}
		},
		'form.stock': function (value) {
			if(this.action == 'dua-stock'){
				return Validator.value(value).required();
			}
		},
		'form.cars': function (value) {
			return Validator.custom( () => {
				if(value.length<=0){
					return true
				}
			})
		},
		'form.file.id': function (value) {
			if(this.action == 'dua-import'){
				return Validator.value(value).required();
			}
		},
	},
	methods: {
		disabledPeriodDate(date) {
			var yesterday = new Date()
			yesterday.setDate(yesterday.getDate())
			return date < yesterday
		},
		selectCar(event){
			this.form.cars.push(event)
		},
		deselectCar(index){
			this.form.cars.splice(index,1)
		},
		searchCars(){
			if(this.search_timeout) clearTimeout(this.search_timeout)
			this.search_timeout = setTimeout(() => {
			
				this.loading = true
				this.$apollo.query({
					query: gql`query ($status: String, $search: String) {
						carsAll(status: $status, search: $search) {
							id
							client{
								name
							}
							model
							brand{
								title
							}
							motor_number
							chassis_number
							status
							statusText
						}
					}`,
					variables: {
						search: this.searchTerms,
						status: this.statusFilter,
					},
				})
				.then((data) => {
					this.loading = false
					this.cars = data.data.carsAll;
				});
			}, 300);
		},
		async save () {
			if(!this.saving && await this.checkValidation() ) {
				this.saving = true
				
				var cars = []
				this.form.cars.forEach(car=>{cars.push(car.id)})
				let dataInput = {
					dua_transit:	this.form.dua_transit,
					dua_import: 	this.form.dua_import,
					stock: 			this.form.stock,
					cars: 			cars,
					file_id     : this.form.file.id,
				}
				this.create(dataInput)
			}
		},
		create (data) {
			this.$apollo.mutate({
				mutation: gql`mutation ( $data: CarBatchUpdateInput! ){
					carBatchUpdate( data: $data) {
						id
					}
				}`,
				variables: {
					data
				}
			})
			.then(() => {
				this.$toast.success('Datos ingresados correctamente')
				this.$router.push('/cars');
				this.saving = false
			})
			.catch( (error) => {
				this.errors = this.parseGQLErrors(error)
				this.$toast.error('Error!')
				this.saving = false
			})

		},
	}
}


</script>


<style scoped>

tr{
	cursor:pointer;
}

</style>